module.exports = __webpack_public_path__ + "static/media/S3N10-3.77f2c3fa.svg";